
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"dropdown-button",class:{ active: isActive },on:{"click":onToggleDropdown}},[_v(_s(activeOption)),_c('div',{staticClass:"dropdown-content"},[_c('ul',_l((options),function(option){return _c('li',[_c('a',{on:{"click":function($event){return onSelect(option)}}},[_v(_s(option))])])}),0)])])}},
      staticRenderFns: []
    };
  